import styled, { css } from "styled-components";

export const LayoutStyle = styled.div<{ width?: number }>`
  background: ${({ theme }) => theme.color.background.white};
  box-shadow: ${({ theme }) => theme.elevation.level1};

  width: ${({ width }) => (width ? width : 70)}rem;
  padding: 5rem;
  box-sizing: border-box;
  border-radius: 2rem;

  display: flex;
  flex-direction: column;
  gap: 3rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      width: 100%;
      padding: 1.6rem;
      padding-top: 3rem;
      margin-top: 0;
      flex: 1;

      border-radius: unset;
      box-shadow: none;
    }
  `}
`;

export const FormHeader = styled.header`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  ${({ theme }) => css`
    h1 {
      ${theme.typography.h1.bold}
    }
    p {
      color: ${theme.color.text.secondary};
      ${theme.typography.body1.regular};
    }

    ${theme.media.small} {
      h1 {
        ${theme.typography.t1.semibold}
      }
      p {
        ${theme.typography.body3.regular};
      }
    }
  `}
`;

export const FormBody = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ gap }) => (gap !== undefined ? gap / 10 : 3.4)}rem;
`;
